import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { LikeFilled, LikeOutlined } from '@ant-design/icons';

import { Tooltip, message } from 'antd';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toggleLikeReview } from '../../actions';

class Like extends Component {

    toggleLike = () => {
        const { review, userDetails } = this.props;
        const likesArray = review.likesArray || [];
        if (!userDetails || !userDetails.uid) {
            message.info('Please sign in to like the review.');
            return;
        }
        const alreadyLiked = userDetails.uid && (likesArray.includes(userDetails.uid));
        console.dir(review);
        if (alreadyLiked) {
            this.props.toggleLikeReview(userDetails.uid, review.id, 'unlike');
        } else {
            this.props.toggleLikeReview(userDetails.uid, review.id, 'like');
        }
    }

    render() {
        const { review, userDetails } = this.props;
        const likesArray = review.likesArray || [];
        const alreadyLiked = userDetails && userDetails.uid && (likesArray.includes(userDetails.uid));

        return (
            <div>
                <Tooltip title={alreadyLiked ? 'Unlike' : 'Like'} placement='left'>
                    <a onClick={this.toggleLike} style={{ display: 'flex', alignItems: 'center' }}>
                        {!alreadyLiked && <>
                            {/* <FontAwesomeIcon icon='thumbs-up' /> */}
                            <LikeOutlined />
                            &nbsp;
                            <h5 style={{ marginBottom: '-3px' }}>
                                {likesArray.length > 0 ? likesArray.length : ''}
                            </h5>
                        </>}
                        {alreadyLiked && <>
                            {/* <FontAwesomeIcon icon='thumbs-up' /> */}
                            <LikeFilled />
                            &nbsp;
                            <h5 style={{ marginBottom: '-3px' }}>
                                {likesArray.length == 1 && `You liked this`}
                                {likesArray.length == 2 && `You and 1 other liked this`}
                                {likesArray.length > 2 && `You and ${likesArray.length - 1} others liked this`}
                            </h5>
                        </>}
                    </a>
                </Tooltip>
            </div>
        );
    }
}

Like.propTypes = {
    userDetails: PropTypes.object,
    review: PropTypes.object.isRequired,
    toggleLikeReview: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggleLikeReview: bindActionCreators(toggleLikeReview, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Like)
